// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CategoriesResponse } from '../../models/category';
import { selectCategories } from '../../store/select-category.selectors';
import { categoriesRequested } from '../../store/select-category.actions';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'coa-select-category-filter',
  templateUrl: './select-category-filter.component.html',
  styleUrls: ['./select-category-filter.component.scss'],
})
export class SelectCategoryFilterComponent implements OnChanges {
  @Input() categoryId: string;
  @Input() clientId: string;
  @Output() filterUpdated = new EventEmitter<string | undefined>();
  categories$: Observable<CategoriesResponse> = this.store$.pipe(select(selectCategories));

  constructor(
    private store$: Store) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clientId && (changes.clientId.currentValue !== changes.clientId.previousValue)) {
      this.store$.dispatch(categoriesRequested({clientId: this.clientId}));
    }
  }

  updated(matSelectChange: MatSelectChange) {
    const value = matSelectChange.value ? matSelectChange.value : undefined;
    this.filterUpdated.emit(value);
  }
}
